import axios from 'axios';
import { uid } from 'uid';

class AutomationService {
  static async getAvailableActions() {
    const response = await axios.get('/automations/available-actions');
    return response.data;
  }

  static async createAutomation(groupId = null) {
    const automation = {
      name: 'New Automation',
      trigger: {
        id: uid(),
        position: { x: 290, y: 50 },
        type: 'trigger',
        data: {
          type: 'form_submission',
          config: {
            formId: null,
          },
        },
      },
      steps: [],
      isActive: false,
      group_id: groupId || null,
    };
    const response = await axios.post('/automations', automation);
    return response;
  }

  static async getAutomations() {
    const response = await axios.get('/automations');
    return response.data;
  }

  static async toggleAutomation(automationId, status = null) {
    const payload = status ? { status } : {};
    const response = await axios.post(`/automations/${automationId}/toggle`, payload);
    return response.data;
  }

  static async deleteAutomation(automationId) {
    const response = await axios.delete(`/automations/${automationId}`);
    return response.data;
  }

  static async createGroup(name) {
    const response = await axios.post('/automations/groups', { name });
    return response.data;
  }

  static async updateGroup(id, payload) {
    const response = await axios.patch(`/automations/groups/${id}`, payload);
    return response.data;
  }

  static async deleteGroup(id) {
    const response = await axios.delete(`/automations/groups/${id}`);
    return response.data;
  }

  static async reorder({ groups, automations }) {
    const response = await axios.post('/automations/reorder', { groups, automations });
    return response.data;
  }

  static async getExecutions(automationId, { status, page = 1, limit = 25 } = {}) {
    const response = await axios.get(`/automations/${automationId}/executions`, {
      params: { status, page, limit },
    });
    return response.data;
  }

  static async getExecution(automationId, executionId) {
    const response = await axios.get(`/automations/${automationId}/executions/${executionId}`);
    return response.data;
  }
}

export default AutomationService;
